import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { NO, YES } from "const"
import {
    StoreType,
    ChangePackageSettings,
    setPackageSettings,
} from "client/store"
import {
    Collapse,
    PageForm,
    FormGroup,
    Label,
    RadioButton,
} from "client/components"

const Task = () => {
    const settings = useSelector((state: StoreType) => state.package.packageSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (newSettings: ChangePackageSettings) => {
        dispatch(setPackageSettings(newSettings))
    }

    const {
        taskModuleAccess,
        subTaskModuleAccess,
        taskGrantView,
        taskKanbanView,
    } = settings

    return (
        <Collapse
            show={show}
            title={lang.task}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>{lang.taskModuleAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={taskModuleAccess === NO}
                            onChange={() => onChange({ taskModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={taskModuleAccess === YES}
                            onChange={() => onChange({ taskModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.subTaskModuleAccess}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={subTaskModuleAccess === NO}
                            onChange={() => onChange({ subTaskModuleAccess: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={subTaskModuleAccess === YES}
                            onChange={() => onChange({ subTaskModuleAccess: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.taskGrantView}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={taskGrantView === NO}
                            onChange={() => onChange({ taskGrantView: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={taskGrantView === YES}
                            onChange={() => onChange({ taskGrantView: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>

                <FormGroup>
                    <Label>{lang.taskKanbanView}</Label>
                    <FormGroup inline>
                        <RadioButton
                            checked={taskKanbanView === NO}
                            onChange={() => onChange({ taskKanbanView: NO })}
                            title={lang.no}
                        />
                        <RadioButton
                            checked={taskKanbanView === YES}
                            onChange={() => onChange({ taskKanbanView: YES })}
                            title={lang.yes}
                        />
                    </FormGroup>
                </FormGroup>
            </PageForm>
        </Collapse>
    )
}
export default Task
